import { useCallback } from 'react'
import { ButtonBase, styled, Typography } from '@mui/material'
import { CustomAction } from '@weblite-wapps/protocol'
import {
  useWappBookmarkData,
  useWappCustomActions,
} from 'weblite-web-wapprunner'
import { desktopAppApi } from '$scenes/components/app/app.desktop.api'
import { CloseIcon } from '$common/icons'
import { getWappTheme } from '$common/wapp-bar-theme'
import { WappPanel } from '$logic/wapp-panels'
import { sendCustomActionToWapp } from '$logic/wapp-communication/helper/wapps.helper'
import { t } from '$i18n'

const Root = styled(ButtonBase)`
  display: flex;
  width: 100%;
  height: 36px;
  background-color: ${({ theme }) => theme.palette.neutral700};
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral000};
  justify-content: center;
  gap: 4px;
`

interface TitleProps {
  hasMargin: boolean
}
const Title = styled(Typography, {
  shouldForwardProp: prop => prop !== 'hasMargin',
})<TitleProps>`
  margin-right: ${props => (props.hasMargin ? 8 : 0)}px;
`

export function WappPanelHeader({
  wappId,
  wappSessionId,
}: {
  wappId: string
  wappSessionId: string
}) {
  const theme = getWappTheme(wappId) // can fetch this from wapp manifest?
  const wappCustomActions = useWappCustomActions(wappSessionId)
  const bookmarkData = useWappBookmarkData(wappSessionId)

  const sendEditEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.EDIT)
  }, [wappSessionId])

  const sendShareEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.SHARE)
  }, [wappSessionId])

  const sendDeleteEvent = useCallback(() => {
    sendCustomActionToWapp(wappSessionId, CustomAction.DELETE)
  }, [wappSessionId])

  const hasEdit = wappCustomActions.includes(CustomAction.EDIT)
  const hasShare = wappCustomActions.includes(CustomAction.SHARE)
  const hasDelete = wappCustomActions.includes(CustomAction.DELETE)

  // TODO: should be handled in another way
  const isOwner = hasEdit || hasDelete
  const shouldShowMenu = hasEdit || hasShare || hasDelete || bookmarkData

  const closeWapp = () => {
    const wappPanelIsFullscreen = desktopAppApi.getWappPanelIsFullscreen()

    if (wappPanelIsFullscreen) desktopAppApi.setWappPanelIsFullscreen(false)
    else WappPanel.closeTopWapp()
  }

  return (
    <Root onClick={closeWapp}>
      <CloseIcon sx={{ color: 'neutral000' }} />
      <Typography variant="subtitle1" color="neutral000" alignSelf="center">
        {t('common.close')}
      </Typography>

      {/* {shouldShowMenu && ( */}
      {/*  <IconButton */}
      {/*    onClick={() => */}
      {/*      showWappBarMenu({ */}
      {/*        isOwner, */}
      {/*        hasEdit, */}
      {/*        hasDelete, */}
      {/*        hasShare, */}
      {/*        sendEditEvent, */}
      {/*        sendShareEvent, */}
      {/*        bookmarkData, */}
      {/*        sendDeleteEvent, */}
      {/*      }) */}
      {/*    } */}
      {/*  > */}
      {/*    <HorizontalMenuIcon sx={{ color: 'gray' }} /> */}
      {/*  </IconButton> */}
      {/* )} */}

      {/* {(hasEdit || true) && ( */}
      {/*  <IconButton onClick={sendEditEvent}> */}
      {/*    <EditOutlinedIcon sx={{ color: 'gray' }} /> */}
      {/*  </IconButton> */}
      {/* )} */}
    </Root>
  )
}
